export default "__VITE_ASSET__CwrcGrmo__"